import { BaseComponent, UserService } from "@mypxplat/xplat/core";
import { Directive, Input } from "@angular/core";

@Directive()
export abstract class OrderItemBaseComponent extends BaseComponent {
  constructor(userService: UserService) {
    super(userService);
  }
}
